import firebase from 'firebase/app';

const storage = () => firebase.storage();

storage.ref = path => firebase.storage().ref(path);

storage.getDownloadURL = ref => ref.getDownloadURL();

storage.put = (ref, data, metadata) => ref.put(data, metadata);

storage.delete = ref => ref.delete();

storage.getMetadata = ref => ref.getMetadata();

export default storage;
